import React, { useState, useEffect } from "react";
import axios from "axios";
import ListGroup from "react-bootstrap/ListGroup";
import { AlertSwal } from "../CustomSwal";
import { FormattedMessage, useIntl } from "react-intl";

function BlackList(props) {
  const [data, setData] = useState(null);
  const sid = sessionStorage.getItem("sid");
  const authid = sessionStorage.getItem("authid");
  const config = props.config;
  const intl = useIntl();

  const GetBlackList = () => {
    props.setLoading(true);
    axios
      .get(config.API_URL + `/GetBlackList.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          restype: "json",
        },
      })
      .then((res) => {
        const data = res.data[0];
        if (data.rescode === "3" || data.rescode === "4") {
          props.setSession(false);
        } else {
          if (data.rescode === "1") {
            if (data.resdata) {
              setData(data.resdata);
            } else {
              setData([]);
            }
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: "global.alert_title" }),
              text: intl.formatMessage({ id: "global.failure" }),
              confirmButtonText: intl.formatMessage({ id: "global.confirm" }),
            });
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        props.setLoading(false);
      });
  };

  useEffect(GetBlackList, []);

  if (data === null) {
    return "Loading";
  }

  return (
    <ListGroup variant="flush">
      <ListGroup.Item>
        <b>
          <FormattedMessage id="info.blacklist" />：
        </b>
      </ListGroup.Item>
      {data.map((row, index) => {
        return (
          <ListGroup.Item key={index} className="text-danger">
            <span className="d-inline-block">
              <FormattedMessage id="info.start_time" />：
              <span className="d-inline-block">{row.blacksdate}</span>
            </span>
            <br />
            <span className="d-inline-block">
              <FormattedMessage id="info.end_time" />：
              <span className="d-inline-block">{row.blackedate}</span>
            </span>
            <br />
            <span className="d-inline-block">
              <FormattedMessage id="info.suspend_reason" />：
              <span className="d-inline-block">{row.reason}</span>
            </span>
            <br />
            <span className="d-inline-block">
              <FormattedMessage id="info.suspend_time" />：
              <span className="d-inline-block">{row.mdate}</span>
            </span>
            <br />
          </ListGroup.Item>
        );
      })}
      {data.length === 0 ? (
        <ListGroup.Item>
          <FormattedMessage id="info.list_empty" />
        </ListGroup.Item>
      ) : null}
    </ListGroup>
  );
}

export default BlackList;
